'use client'

import React, { FC, ReactElement } from 'react'
import InscriptionCard from '@/components/inscription-card'
import { Inscription } from '@/utils/types/inscription'

const InscriptionCardWithPreview: FC<{
	inscription: Inscription
	footer?: React.ReactNode
	showSetPfp?: boolean
	showSetSns?: boolean
	subtitle?: string
	onClick?: (evt: any) => void
	selected?: boolean
	disablePreview?: boolean
}> = (props): ReactElement => {
	const { inscription, onClick, disablePreview: _disablePreview, ...rest } = props

	return (
		<InscriptionCard
			inscription={inscription}
			onClick={onClick}
			{...rest}
		/>
	)
}

export default InscriptionCardWithPreview
